import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';
import Global from "../config";
import RigsenseDoUpdate from './RigsenseDoUpdate';
import RigsenseAlreadyUpdate from './RigsenseAlreadyUpdate';
        
async function getData() {
  const url = Global.SNURL + "/" + Global.SNFILE;
  console.log(Global.SNURL);
  try {
    const response = await fetch(url, {
      headers: {
         "Accept":"*/*",
         "Host": Global.HOST,
         "Cache-Control": "private, no-cache, no-store, must-revalidate",
         "Expires": "-1",
         "Pragma": "no-cache",
         "Access-Control-Allow-Origin":"*",         
      },
      method: 'GET',
      /*withCredentials: true,
      crossorigin: true,
      mode: 'no-cors',*/
    })        
    if (!response.ok) {
      throw new Error('Response status: %s',response.status);
    }
    
    let resultg = await response.text();
    let desc=resultg.split("\n");
    let result=desc[0];
    desc=resultg.substring(result.length);
    Global.WFDesc=desc;

    result=result.replace('\r','').replace('\n','').trim();
    console.log(result.length);
    console.log(result);
    Global.WFileName=result;

    let DotPF=result.indexOf('_');
    let DotPE=result.toUpperCase().indexOf('.BIN');
    let WVer=result.substring(DotPF+1,DotPE).replace('_',".");
    console.log('Web Version: %s',WVer);

    Global.WVersion = WVer;

    return;
  } catch (error) {
    throw new Error('Web Get Version: %s!',error.message);
  }
}

/* BTConnect
 * Brings up the bluetooth connection window and filters for the esp32
 */
async function BTConnectNew(){
  try {
    let device = await navigator.bluetooth.requestDevice({
      filters: [{
        namePrefix: 'SNRS'
      }],
      optionalServices: [Global.otaServiceUuid,Global.myESP32]
    })

    document.getElementById("connect").style.visibility="hidden";

    Global.esp32Device = device;
    let server = await Global.esp32Device.gatt.connect()
  
    Global.esp32Service=await server.getPrimaryService(Global.myESP32);
    //console.dir(esp32Service);
    Global.espOTAService=await server.getPrimaryService(Global.otaServiceUuid);
    CompareVersions();
  } catch (error) {
    console.log('Error: Discover Device Services: %s',error.message);
  }
}

function CompareVersions() {
  var SCVer;

  Global.esp32Service.getCharacteristic(Global.versionCharacteristicUuid)
  .then(characteristic => characteristic.readValue())
  .then(value => {
    Global.softwareVersion = 'v' + value;
    
    var enc = new TextDecoder("utf-8");
    let CVer=enc.decode(value);
    let DotP=CVer.indexOf('.');
    SCVer=CVer.substring(0,DotP+2);

    Global.DVersion=SCVer;

    console.log('Device Software Version: %s',Global.DVersion);
  })
  .then (function() {

    var WVC = parseFloat(Global.WVersion);
    var DVC = parseFloat(Global.DVersion);
    if (DVC<WVC) {
      console.log("Old Version");
      ReactDOM.render(
        <React.StrictMode>
          <RigsenseDoUpdate />    
        </React.StrictMode>,
        document.getElementById('root')
      );  
    } else {
      console.log("Current Version");
      ReactDOM.render(
        <React.StrictMode>
          <RigsenseAlreadyUpdate />    
        </React.StrictMode>,
        document.getElementById('root')
      );  
    }
  })
          
  .catch(error => { console.log(Global.softwareVersion + ":::" + error); });  
}

/* CheckVersion()
 * Grab most current version from Github and Server, if they don't match, prompt the user for firmware update
 */
async function CheckVersion(){
  await getData();
  document.getElementById("SVersion").innerText=Global.WVersion;
  document.getElementById("SDesc").innerText=Global.WFDesc;
  document.getElementById("UpdateDiv").style.visibility = "visible";
}

function Rigsense() {
  CheckVersion();
  return (
  <div className="App">
    <header className="App-body">
      <svg width="300" height="161" viewBox="0 0 500 161" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M72.0201 22.458C70.3939 15.1599 61.3908 13.8842 56.734 13.9287C47.7899 14.0325 44.2714 16.8212 44.2123 20.6334C44.0497 33.509 85.5027 21.8201 85.2071 42.4388C85.0297 54.0683 73.0402 60.8027 58.9515 60.5802C44.7297 60.3577 31.8385 55.7742 30.7593 43.5513H44.1236C44.7445 49.4996 53.4964 51.8136 59.5133 51.8136C65.131 51.8136 71.9314 49.9297 72.4341 45.0643C73.1141 38.4782 59.1289 38.3299 54.9895 37.7365C42.113 35.8823 31.0254 34.755 31.0254 22.3838C31.0254 11.2735 43.074 5.5477 57.5766 5.72571C72.0941 5.90371 83.3 10.1461 85.3845 22.458H72.0201Z" fill="white"/>
        <path d="M106.998 16.0498C106.998 16.0498 114.937 6.60084 126.749 6.55634C144.164 6.497 153.359 20.7817 153.256 33.5089C153.167 44.6193 145.45 60.15 128.316 60.3132C114.39 60.4467 107.027 50.5378 107.027 50.5378V60.6692H94.8311C94.8311 60.6692 94.8311 11.8816 94.8311 9.10771H107.072L106.998 16.0498ZM123.969 50.7307C135.885 50.7159 139.655 40.4065 139.832 33.1678C140.039 24.6978 134.909 15.7977 123.969 15.7383C114.316 15.6938 107.027 22.8139 107.027 33.1678C107.042 44.3078 113.207 50.7455 123.969 50.7307Z" fill="white"/>
        <path d="M175.697 9.04834H163.072V58.1623H175.697V9.04834Z" fill="white"/>
        <path d="M203.135 16.1986C203.135 16.1986 211.045 6.03763 223.596 6.79415C244.618 8.055 245.638 23.8972 245.638 25.3806V58.1628H233.057V26.5821C232.821 20.174 226.952 16.0503 218.629 15.7684C209.507 15.4421 203.328 21.9244 203.091 28.2583V58.1628L189.549 58.0886V9.18233H203.121V16.1986H203.135Z" fill="white"/>
        <path d="M269.425 0H256.667V58.118H269.425V0Z" fill="white"/>
        <path d="M309.754 60.5362C289.989 60.5362 278.118 47.8535 278.118 33.1535C278.118 18.4682 289.959 5.63721 309.725 5.63721C329.49 5.63721 341.258 18.4682 341.258 33.1535C341.258 47.8535 329.609 60.5362 309.754 60.5362ZM309.725 52.4964C320.813 52.4964 328.027 43.4776 327.983 33.1683C327.953 22.4733 320.798 13.5583 309.725 13.5583C298.637 13.5583 291.512 22.6068 291.526 33.1683C291.541 43.4776 298.637 52.4964 309.725 52.4964Z" fill="white"/>
        <path d="M392.424 24.7873C391.803 18.7352 385.003 13.3506 376.399 13.8846C367.543 14.4335 362.044 21.2717 361.379 32.3227C360.61 45.1834 369.48 51.2207 376.414 51.3839C385.298 51.5915 389.734 48.254 392.675 39.7543H404.547C404.014 52.2887 391.936 60.64 376.399 60.462C358.097 60.2395 347.94 46.5629 347.94 32.6491C347.94 18.75 357.964 5.54814 376.399 4.83612C393.489 4.18345 405.108 15.6943 404.547 24.8021H392.424V24.7873Z" fill="white"/>
        <path d="M425.953 60.2687H413.002V1.76514H425.982V33.1085L451.351 10.9323H466.401L445.63 29.3556L468.5 60.2687H453.835L436.656 37.3954L425.953 46.874V60.2687Z" fill="white"/>
        <path d="M100.996 88.7644C106.954 88.7644 111.788 83.9138 111.788 77.9359C111.788 71.958 106.954 67.1074 100.996 67.1074C95.0383 67.1074 90.2041 71.958 90.2041 77.9359C90.2041 83.9138 95.0383 88.7644 100.996 88.7644Z" fill="white"/>
        <path d="M159.057 144.498V113.212H165.314C169.604 113.212 170.588 115.357 170.588 118.575V126.039C170.588 128.676 170.007 130.419 167.727 131.089C169.247 135.559 170.722 140.028 172.197 144.498H167.683C166.431 140.118 165.09 135.693 163.839 131.268H163.213V144.498H159.057ZM163.213 127.469H165.001C166.118 127.469 166.476 126.933 166.476 125.905V118.754C166.476 117.681 166.074 117.189 164.956 117.189H163.213V127.469ZM175.566 144.498V113.212H179.722V144.498H175.566ZM190.41 130.598V126.754H196.22V139.358C196.22 142.576 194.924 144.945 190.41 144.945C185.896 144.945 184.644 142.576 184.644 139.358V118.396C184.644 115.133 185.896 112.765 190.41 112.765C194.879 112.765 196.175 115.133 196.175 118.396V122.15H192.063V118.351C192.063 117.279 191.616 116.519 190.41 116.519C189.203 116.519 188.801 117.279 188.801 118.351V139.313C188.801 140.475 189.203 141.235 190.41 141.235C191.616 141.235 192.063 140.475 192.063 139.313V130.598H190.41ZM200.449 133.458V130.508H208.048V133.458H200.449ZM219.445 139.358V135.872C219.445 127.246 212.07 130.508 212.07 121.078V118.351C212.07 115.133 213.456 112.765 217.836 112.765C222.216 112.765 223.601 115.133 223.601 118.351V122.15H219.445V118.351C219.445 117.279 219.087 116.519 217.836 116.519C216.629 116.519 216.227 117.279 216.227 118.351V120.944C216.227 128.363 223.601 125.056 223.601 135.782V139.402C223.601 142.62 222.216 144.945 217.836 144.945C213.456 144.945 212.07 142.62 212.07 139.402V135.112H216.227V139.358C216.227 140.43 216.629 141.235 217.836 141.235C219.087 141.235 219.445 140.43 219.445 139.358ZM232.446 130.598V140.564H237.809V144.498H228.289V113.212H237.809V117.189H232.446V126.754H237.094V130.598H232.446ZM246.463 113.212L251.692 134.844C251.424 131.089 251.334 126.888 251.334 123.134V113.212H255.089V144.498H251.156L245.882 122.91C246.105 126.575 246.239 130.687 246.239 134.62V144.498H242.485V113.212H246.463ZM267.138 139.358V135.872C267.138 127.246 259.764 130.508 259.764 121.078V118.351C259.764 115.133 261.149 112.765 265.529 112.765C269.909 112.765 271.295 115.133 271.295 118.351V122.15H267.138V118.351C267.138 117.279 266.781 116.519 265.529 116.519C264.323 116.519 263.92 117.279 263.92 118.351V120.944C263.92 128.363 271.295 125.056 271.295 135.782V139.402C271.295 142.62 269.909 144.945 265.529 144.945C261.149 144.945 259.764 142.62 259.764 139.402V135.112H263.92V139.358C263.92 140.43 264.323 141.235 265.529 141.235C266.781 141.235 267.138 140.43 267.138 139.358ZM280.14 130.598V140.564H285.503V144.498H275.983V113.212H285.503V117.189H280.14V126.754H284.788V130.598H280.14ZM297.784 144.498V113.212H303.996C308.287 113.212 309.315 115.357 309.315 118.575V125.994C309.315 129.346 307.885 131.313 303.907 131.313H301.94V144.498H297.784ZM301.94 127.469H303.728C304.845 127.469 305.203 126.933 305.203 125.905V118.754C305.203 117.681 304.801 117.189 303.683 117.189H301.94V127.469ZM313.769 144.498V113.212H320.026C324.317 113.212 325.3 115.357 325.3 118.575V126.039C325.3 128.676 324.719 130.419 322.44 131.089C323.959 135.559 325.434 140.028 326.909 144.498H322.395C321.143 140.118 319.803 135.693 318.551 131.268H317.925V144.498H313.769ZM317.925 127.469H319.713C320.831 127.469 321.188 126.933 321.188 125.905V118.754C321.188 117.681 320.786 117.189 319.669 117.189H317.925V127.469ZM335.641 141.235C336.848 141.235 337.25 140.475 337.25 139.313V118.396C337.25 117.323 336.848 116.519 335.641 116.519C334.434 116.519 333.988 117.323 333.988 118.396V139.313C333.988 140.475 334.434 141.235 335.641 141.235ZM335.641 144.945C331.127 144.945 329.831 142.576 329.831 139.358V118.396C329.831 115.178 331.127 112.765 335.641 112.765C340.155 112.765 341.407 115.178 341.407 118.396V139.358C341.407 142.576 340.155 144.945 335.641 144.945Z" fill="white"/>
      </svg>

    <div>
      <b><label>Latest Firmware version:</label></b><br/>
      <b><label id="SVersion">Checking...</label></b><br/>
      <label id="SDesc"></label>
    </div>

    <br/>
    <div className="Update-div" id="UpdateDiv">
      <b><label>To Update Device:</label></b><br/>
      <label>Connect to Rig-Sense Pro using a BT enabled</label><br/>
      <label>Windows PC or Android device.</label><br/>

      <br/>
      <button className="Button" id="connect"
        onClick={BTConnectNew}
      >
        <svg width="150" height="58" viewBox="0 0 150 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="150" height="57.0218" rx="28.5109" fill="#0079DC"/>
        <path d="M39.1315 36.2507C34.7915 36.2507 31.5515 33.2307 31.5515 29.0107C31.5515 24.7907 34.7915 21.7707 39.1515 21.7707C41.5715 21.7707 43.5915 22.6507 44.9115 24.2507L42.8315 26.1707C41.8915 25.0907 40.7115 24.5307 39.3115 24.5307C36.6915 24.5307 34.8315 26.3707 34.8315 29.0107C34.8315 31.6507 36.6915 33.4907 39.3115 33.4907C40.7115 33.4907 41.8915 32.9307 42.8315 31.8307L44.9115 33.7507C43.5915 35.3707 41.5715 36.2507 39.1315 36.2507ZM51.6284 36.1707C48.2084 36.1707 45.7084 33.8707 45.7084 30.6307C45.7084 27.3907 48.2084 25.0907 51.6284 25.0907C55.0484 25.0907 57.5284 27.3907 57.5284 30.6307C57.5284 33.8707 55.0484 36.1707 51.6284 36.1707ZM51.6284 33.6107C53.1884 33.6107 54.3684 32.4907 54.3684 30.6307C54.3684 28.7707 53.1884 27.6507 51.6284 27.6507C50.0684 27.6507 48.8684 28.7707 48.8684 30.6307C48.8684 32.4907 50.0684 33.6107 51.6284 33.6107ZM66.1539 25.0907C68.6939 25.0907 70.6139 26.5707 70.6139 29.8507V36.0107H67.4939V30.3307C67.4939 28.5907 66.6939 27.7907 65.3139 27.7907C63.8139 27.7907 62.7339 28.7107 62.7339 30.6907V36.0107H59.6139V25.2507H62.5939V26.5107C63.4339 25.5907 64.6939 25.0907 66.1539 25.0907ZM79.982 25.0907C82.522 25.0907 84.442 26.5707 84.442 29.8507V36.0107H81.322V30.3307C81.322 28.5907 80.522 27.7907 79.142 27.7907C77.642 27.7907 76.562 28.7107 76.562 30.6907V36.0107H73.442V25.2507H76.422V26.5107C77.262 25.5907 78.522 25.0907 79.982 25.0907ZM97.9273 30.6707C97.9273 30.9107 97.8873 31.2507 97.8673 31.5107H89.7273C90.0273 32.8507 91.1673 33.6707 92.8073 33.6707C93.9473 33.6707 94.7673 33.3307 95.5073 32.6307L97.1673 34.4307C96.1673 35.5707 94.6673 36.1707 92.7273 36.1707C89.0073 36.1707 86.5873 33.8307 86.5873 30.6307C86.5873 27.4107 89.0473 25.0907 92.3273 25.0907C95.4873 25.0907 97.9273 27.2107 97.9273 30.6707ZM92.3473 27.4507C90.9273 27.4507 89.9073 28.3107 89.6873 29.6907H94.9873C94.7673 28.3307 93.7473 27.4507 92.3473 27.4507ZM105.204 36.1707C101.704 36.1707 99.2045 33.8707 99.2045 30.6307C99.2045 27.3907 101.704 25.0907 105.204 25.0907C107.464 25.0907 109.244 26.0707 110.024 27.8307L107.604 29.1307C107.024 28.1107 106.164 27.6507 105.184 27.6507C103.604 27.6507 102.364 28.7507 102.364 30.6307C102.364 32.5107 103.604 33.6107 105.184 33.6107C106.164 33.6107 107.024 33.1707 107.604 32.1307L110.024 33.4507C109.244 35.1707 107.464 36.1707 105.204 36.1707ZM118.077 33.2907L118.917 35.4907C118.277 35.9507 117.337 36.1707 116.377 36.1707C113.837 36.1707 112.357 34.8707 112.357 32.3107V27.8907H110.697V25.4907H112.357V22.8707H115.477V25.4907H118.157V27.8907H115.477V32.2707C115.477 33.1907 115.977 33.6907 116.817 33.6907C117.277 33.6907 117.737 33.5507 118.077 33.2907Z" fill="white"/>
        </svg>
      </button>
    </div>

    </header>
  </div>

)
}
export default Rigsense;